import axiosInstance from "./axiosInstance";

const API_URL =
  process.env.REACT_APP_NAS_API_URL || "https://new.aquastrong-select.ru";

export const getCurrencyRate = (data) =>
  axiosInstance.post(`${API_URL}/api/v1/currency`, data);
